<div class="news-wrapper">
  <div class="news-img">
    <img src="{{news.imgs[0]}}" alt="">
  </div>
  <div class="date-info">
    <div class="date" [innerHTML]="news.date"></div>
    <div class="info" [innerHTML]="news.text"></div>
  </div>
</div>
